import n, { css as t } from "styled-components";
const a = n.div.withConfig({
  displayName: "Ring",
  componentId: "sc-1pkpo1f-0"
})(["display:inline-block;height:100%;position:relative;width:100%;& div{animation:lds-ring 1.2s cubic-bezier(0.5,0,0.5,1) infinite;border-radius:var(--size-border-radius-circle);box-sizing:border-box;display:block;height:100%;position:absolute;width:100%;", "}& div:nth-child(1){animation-delay:-0.45s;}& div:nth-child(2){animation-delay:-0.3s;}& div:nth-child(3){animation-delay:-0.15s;}@keyframes lds-ring{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], ({
  color: r = "currentColor",
  size: i
}) => {
  const e = typeof i == "number" ? `${i}px` : `var(--size-icon-${i})`;
  return t(["border:calc(", " / 5) solid ", ";border-color:", " transparent transparent transparent;"], e, r, r);
});
export {
  a as Ring
};
//# sourceMappingURL=style.es.js.map
